import { useState, type FormEvent } from 'react';
import { api } from '../lib/api';

export function PasswortFestlegen() {
  const [bisher, setBisher] = useState('');
  const [neu, setNeu] = useState('');
  const [bestätigung, setBestätigung] = useState('');
  const [fehler, setFehler] = useState('');
  const [lädt, setLädt] = useState(false);
  const [fertig, setFertig] = useState(false);

  async function speichern(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setFehler('');

    if (neu.length < 12 || neu.length > 128) {
      setFehler('Dein neues Passwort muss zwischen 12 und 128 Zeichen lang sein.');
      return;
    }

    if (neu !== bestätigung) {
      setFehler('Die beiden neuen Passwörter stimmen nicht überein.');
      return;
    }

    if (neu === bisher) {
      setFehler('Bitte wähle ein anderes Passwort als bisher.');
      return;
    }

    setLädt(true);
    try {
      await api.passwortÄndern(bisher, neu);
      setFertig(true);
      setBisher('');
      setNeu('');
      setBestätigung('');
    } catch (error) {
      setFehler(error instanceof Error ? error.message : 'Passwort konnte nicht gespeichert werden.');
    } finally {
      setLädt(false);
    }
  }

  if (fertig) {
    return (
      <main className="page">
        <section className="panel" style={{ maxWidth: 480, margin: '3rem auto' }}>
          <h1>Passwort gespeichert!</h1>
          <p>Dein persönliches Passwort wurde erfolgreich eingerichtet.</p>
          <p>Bitte melde dich jetzt mit deinem neuen Passwort an.</p>
          <button type="button" onClick={() => window.location.assign('/')}>
            Zur Anmeldung
          </button>
        </section>
      </main>
    );
  }

  return (
    <main className="page">
      <section className="panel" style={{ maxWidth: 480, margin: '3rem auto' }}>
        <h1>Dein persönliches Passwort</h1>
        <p>
          Willkommen bei Win-Challenge! Bevor du mitspielen kannst,
          lege bitte dein eigenes Passwort fest.
        </p>
        <p className="muted">
          Dein Passwort muss mindestens 12 Zeichen enthalten.
          Die Lobbyerstellerin kann dein persönliches Passwort nicht sehen.
        </p>

        <form onSubmit={(event) => void speichern(event)}>
          <label htmlFor="bingo-passwort-alt">Bisheriges Passwort</label>
          <input
            id="bingo-passwort-alt"
            type="password"
            autoComplete="current-password"
            value={bisher}
            onChange={(event) => setBisher(event.target.value)}
            required
          />

          <label htmlFor="bingo-passwort-neu">Neues Passwort</label>
          <input
            id="bingo-passwort-neu"
            type="password"
            autoComplete="new-password"
            minLength={12}
            maxLength={128}
            value={neu}
            onChange={(event) => setNeu(event.target.value)}
            required
          />

          <label htmlFor="bingo-passwort-bestätigen">Neues Passwort bestätigen</label>
          <input
            id="bingo-passwort-bestätigen"
            type="password"
            autoComplete="new-password"
            value={bestätigung}
            onChange={(event) => setBestätigung(event.target.value)}
            required
          />

          {fehler && <p role="alert" style={{ color: '#ff8080' }}>{fehler}</p>}

          <button type="submit" disabled={lädt}>
            {lädt ? 'Wird gespeichert …' : 'Persönliches Passwort speichern'}
          </button>
        </form>
      </section>
    </main>
  );
}
